export default __webpack_public_path__ + "static/MSpartner-7d410ed6707561587a5dbf08e2af33ec.png";